import React, { useState } from "react";
import { 
  useMyIdentities,
  ViewMe 
} from "@njoy/controller";
import { useLocation, Link } from "react-router-dom";

import DiscoverIconWhite from "../../assets/images/discover-white.svg";
import WalletWhite from "../../assets/images/wallet-white.svg";
import WalletIcon from "../../assets/images/wallet-icon.svg";
import ProfileIcon from "../../assets/images/profile-icon.svg";
import ProfileWhite from "../../assets/images/profile-white.svg";
import DiscoverIconGrey from "../../assets/images/discover-icon-grey1.svg";
import HomeIconGrey from "../../assets/images/home-icon-new.svg";
import HomeIconWhite from "../../assets/images/home-icon-new-white.svg";
import AlertsGrey from "../../assets/alerts/alerts-icon-grey.svg";
import AlertsWhite from "../../assets/images/alerts-icon-white.svg";
import { ConnectIdModal } from "../modals/connectIdModal";
import { ComingSoonModal } from "../modals/comingSoonModal";

import * as ROUTES from "../../constants/routes";
import { AccessWalletModal } from "../modals/accessYourWallet";

interface Props {
  offset: number;
  limit: number;
}


export const MobileTab: React.FC<Props> = ({ offset, limit }) => {
  const location = useLocation();
  const isActive = (link: string) => location.pathname.startsWith(link);
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  const [openAccessWallet, setOpenAccessWallet] = React.useState(false);
  const { myIdentities } = useMyIdentities({ offset, limit });

  return (
    <ViewMe>
      {({ match }) => {
        const handleLinkClick = (e: React.MouseEvent, to: string) => {
          e.preventDefault();
          if (!myIdentities.length) {
            // e.preventDefault(); 
            setShowConnectModal(true);
          } else {
            // e.preventDefault(); 
            setShowComingSoonModal(true);
            // const nin = match?.customer?.nin;
            // const dob = match?.customer?.dob;
            // if (!nin || nin.trim() === "" || !dob || dob.trim() === "") {
            //   e.preventDefault(); 
            //   setOpenAccessWallet(true);
            // }
          }
        };

        return (
          <div className="relative w-full">
            <div className="absolute bottom-[0px] left-[0px] right-[0px]  w-full   h-[107px]">
              <svg
              width="100%"
              height="107"
              viewBox="0 0 393 107"
              fill="none"
              preserveAspectRatio="none">
                <path
                  d="M197.5 0C208.268 0 217.947 4.66323 224.628 12.0804C230.253 18.3253 237.395 24 245.8 24H392C392.552 24 393 24.4477 393 25V106C393 106.552 392.552 107 392 107H1C0.447715 107 0 106.552 0 106V25C0 24.4477 0.447715 24 1 24H149.2C157.605 24 164.747 18.3253 170.372 12.0804C177.053 4.66323 186.732 0 197.5 0Z"
                  fill="#1E1E1E"
                />
              </svg>
            </div>

            <div className="relative flex justify-around items-end pb-5 pt-3 h-[80px]">
              {/* Home Tab */}
              <Link
              to={ROUTES.HOME}
              className="flex flex-col items-center justify-end gap-1 w-16 z-10 h-full">
                {isActive(ROUTES.HOME) ? (
                  <img src={HomeIconWhite} alt="home" className="w-6 h-6" />
                ) : (
                  <img src={HomeIconGrey} alt="home" className="w-6 h-6" />
                )}
                <span className={`text-xs font-medium ${isActive(ROUTES.HOME) ? "text-white" : "text-[#787878]"}`}>
                  Home
                </span>
              </Link>

              {/* Wallet Tab */}
              <Link
              to={ROUTES.VIEW_WALLET}
              className="flex flex-col items-center mr-[40px] justify-end gap-1 w-16 z-10 h-full"
              onClick={(e) => handleLinkClick(e, ROUTES.VIEW_WALLET)}>
                {isActive(ROUTES.VIEW_WALLET) ? (
                  <img src={WalletWhite} alt="wallet" className="w-6 h-6" />
                ) : (
                  <img src={WalletIcon} alt="wallet" className="w-6 h-6" />
                )}
                <span className={`text-xs font-medium ${isActive(ROUTES.VIEW_WALLET) ? "text-white" : "text-[#787878]"}`}>
                  Wallet
                </span>
              </Link>

              {/* Discover Tab  */}
              <Link
              to={ROUTES.DISCOVER}
              className="flex flex-col items-center absolute left-1/2 transform -translate-x-1/2 bottom-5 z-20">
                <div className="p-3 flex items-center justify-center mb-1 rounded-full w-14 h-14 bg-gradient-to-l from-[color:var(--brand-gradient-from)] to-[color:var(--brand-gradient-to)] shadow-lg">
                  {isActive(ROUTES.DISCOVER) ? (
                    <img src={DiscoverIconWhite} alt="discover" className="w-6 h-6" />
                  ) : (
                    <img src={DiscoverIconGrey} alt="discover" className="w-6 h-6" />
                  )}
                </div>
                <span className={`text-xs font-medium ${isActive(ROUTES.DISCOVER) ? "text-white" : "text-[#787878]"}`}>
                  Discover
                </span>
              </Link>

              {/* Alerts Tab */}
              <Link
              to={ROUTES.ALERTS}
              className="flex flex-col items-center ml-[40px] justify-end gap-1 w-16 z-10 h-full">
                {isActive(ROUTES.ALERTS) ? (
                  <img src={AlertsWhite} alt="alerts" className="w-6 h-6" />
                ) : (
                  <img src={AlertsGrey} alt="alerts" className="w-6 h-6" />
                )}
                <span className={`text-xs font-medium ${isActive(ROUTES.ALERTS) ? "text-white" : "text-[#787878]"}`}>
                  Alerts
                </span>
              </Link>

              {/* Profile Tab */}
              <Link
              to={ROUTES.PROFILE}
              className="flex flex-col items-center justify-end gap-1 w-16 z-10 h-full">
                {isActive(ROUTES.PROFILE) ? (
                  <img src={ProfileWhite} alt="profile" className="w-6 h-6" />
                ) : (
                  <img src={ProfileIcon} alt="profile" className="w-6 h-6" />
                )}
                <span className={`text-xs font-medium ${isActive(ROUTES.PROFILE) ? "text-white" : "text-[#787878]"}`}>
                  Profile
                </span>
              </Link>
            </div>

            <ConnectIdModal
            visible={showConnectModal}
            onCancel={() => setShowConnectModal(false)}
            onOk={() => setShowConnectModal(false)} />

            <ComingSoonModal
            visible={showComingSoonModal}
            onCancel={() => setShowComingSoonModal(false)}
            onOk={() => setShowComingSoonModal(false)} />

            <AccessWalletModal
            isOpen={openAccessWallet}
            onClose={() => setOpenAccessWallet(false)} />
          </div>
        );
      }}
    </ViewMe>
  );
};
